import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import type { AreaItem } from '../../types/areas.types'

export type AreaProps = {
	booth: AreaItem
	menuOptions: Option[]
}

export const Area = ({ booth, menuOptions }: AreaProps) => {
	const { t } = useTranslation()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{booth.number}</p>
				<ContextMenu
					dataId={booth.id}
					item={booth}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: booth.number })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail label={t('Type')} value={booth.booth_type_name} />
				<Detail label={t('Status')} value={booth.is_active ? t('Active') : t('Inactive')} />
			</dl>
		</li>
	)
}
